import { render, staticRenderFns } from "./ForgetPasswordForm.vue?vue&type=template&id=fa5d1cb8&scoped=true&"
import script from "./ForgetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPasswordForm.vue?vue&type=style&index=0&id=fa5d1cb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5d1cb8",
  null
  
)

export default component.exports